import axios from 'axios'

export default{
    namespaced: true,

    state: {
        lineSubjectChosen: {},
        application: {},
        studentId: null,
    },

    getters: {
       getLineSubjectChosen(state){
           return state.lineSubjectChosen
       },

       getApplication(state){
           return state.application
       }, 
       
       getStudentId(state){
           return state.studentId
       }
    },

    mutations: {
      setLineSubjectChosen(state, payload){
            state.lineSubjectChosen = payload
        },

        setApplication(state, payload){
            state.application = payload
        },

        setStudentId(state, payload){
            state.studentId = payload
        }
    },

    actions: {
        getCsecSubjectApplications(){
            const url = '/api/csec-subject-applications';
            return axios.get(url);
        },

        downloadApplications(){
            return axios({
                method: 'get',
                url: '/api/csec-subject-applications-spreadsheet',
                responseType: 'arraybuffer',
            });
        },

        getCsecSubjectSelectionLines(){
            const url = '/api/csec-subject-selection-lines';
            return axios.get(url);
        },

        postSubjectSelectionLine({ getters}){
            const url = '/api/csec-subject-choice/assign';
            return axios.post(url, getters.getLineSubjectChosen);
        },

        getSubjectChoice({ getters }){
            const url = '/api/csec-subject-choice';
            return axios.get(url, {
                params: {
                    student_id: getters.getStudentId
                }
            });
        },

        postApplication({ getters }){
            const url = '/api/csec-subject-selection-application';
            return axios.post(url, getters.getApplication);
        },

        getApplication({ getters}){
            console.log('student_id: ', getters.getStudentId);
            const url = '/api/csec-subject-selection-application';
            return axios.get(url, {
                params: {
                    student_id: getters.getStudentId
                }
            });
        },

    }
}